export interface PaletteEntry {
  name: string;
  utility: string;
  swatchClassName: string;
  token: string;
}

export const SURFACES: PaletteEntry[] = [
  {
    name: "page",
    utility: "bg-page",
    swatchClassName: "bg-page",
    token: "--color-page",
  },
  {
    name: "surface",
    utility: "bg-surface",
    swatchClassName: "bg-surface",
    token: "--color-surface",
  },
  {
    name: "surface-muted",
    utility: "bg-surface-muted",
    swatchClassName: "bg-surface-muted",
    token: "--color-surface-muted",
  },
  {
    name: "hairline",
    utility: "border-hairline",
    swatchClassName: "bg-hairline",
    token: "--color-hairline",
  },
];

export const TEXT: PaletteEntry[] = [
  {
    name: "ink-body",
    utility: "text-ink-body",
    swatchClassName: "bg-ink-body",
    token: "--color-ink-body",
  },
  {
    name: "ink-display",
    utility: "text-ink-display",
    swatchClassName: "bg-ink-display",
    token: "--color-ink-display",
  },
  {
    name: "ink-muted",
    utility: "text-ink-muted",
    swatchClassName: "bg-ink-muted",
    token: "--color-ink-muted",
  },
  {
    name: "placeholder",
    utility: "text-placeholder",
    swatchClassName: "bg-placeholder",
    token: "--color-placeholder",
  },
];

export const SPLASH: PaletteEntry[] = [
  {
    name: "accent",
    utility: "bg-accent / text-accent",
    swatchClassName: "bg-accent",
    token: "--color-accent",
  },
  {
    name: "accent-hover",
    utility: "bg-accent-hover / text-accent-hover",
    swatchClassName: "bg-accent-hover",
    token: "--color-accent-hover",
  },
  {
    name: "verified",
    utility: "bg-verified / text-verified",
    swatchClassName: "bg-verified",
    token: "--color-verified",
  },
  {
    name: "signal",
    utility: "bg-signal / text-signal",
    swatchClassName: "bg-signal",
    token: "--color-signal",
  },
  {
    name: "signal-faded",
    utility: "bg-signal-faded",
    swatchClassName: "bg-signal-faded",
    token: "--color-signal-faded",
  },
  {
    name: "danger",
    utility: "bg-danger / text-danger",
    swatchClassName: "bg-danger",
    token: "--color-danger",
  },
  {
    name: "danger-faded",
    utility: "bg-danger-faded",
    swatchClassName: "bg-danger-faded",
    token: "--color-danger-faded",
  },
];

export const FONTS = {
  display: "Source Serif 4",
  body: "Source Sans 3",
};
